import { emojiName, maxEmojiName } from "@beacon/core/custom-emoji/names"

/*
 * Custom emoji in words: a name to start from, what is wrong with one as it is typed, and each
 * refusal of the web API's.
 */

/** A name for an emoji made from a file, from the file's own name, as a name can be written. */
export function nameFromFile(fileName: string): string {
  return fileName
    .replace(/\.[^.]*$/, "")
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_-]/g, "")
    .slice(0, maxEmojiName)
}

/** What is wrong with a name as typed, or none when it will do (`emojiName`). */
export function namingProblem(typed: string): string | undefined {
  if (emojiName(typed)) return undefined
  const name = typed.trim().replace(/^:(.*):$/, "$1")
  if (name === "") return "Name it, as people will type it between colons."
  if (name.length < 2) return "A name is at least 2 characters."
  if (name.length > maxEmojiName) return `A name is at most ${maxEmojiName} characters.`
  return "Use lower-case letters, digits, hyphens and underscores."
}

const refusals: Record<string, string> = {
  "not-found": "That emoji or upload is gone. Try again.",
  "not-an-admin": "Only an Admin can rename or remove a custom emoji.",
  "invalid-name": "Use lower-case letters, digits, hyphens and underscores.",
  "name-taken": "That name is taken, by another custom emoji or a standard one.",
  "invalid-image": "Choose a PNG, JPEG, GIF or WebP picture.",
  "too-large": "Choose a picture of 2 MB or less.",
  unreadable: "That file isn't a picture Beacon can use. Choose a PNG, JPEG, GIF or WebP.",
  "upload-failed": "The picture didn't upload. Try again.",
}

/** A refusal of the web API's, or a failed upload, in words. */
export function describeCustomEmojiRefusal(refusal: string): string {
  return refusals[refusal] ?? "That didn't work. Try again."
}
